import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RotateCounterclockwiseAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 21V12C10.5008 11.1719 11.1719 10.5008 12 10.5H21C21.8281 10.5008 22.4992 11.1719 22.5 12V21C22.4992 21.8281 21.8281 22.4992 21 22.5H12C11.1719 22.4992 10.5008 21.8281 10.5 21ZM12 12L11.9992 21H21V12H12ZM1.5 11.25L2.5575 10.1925L4.5 12.1275V8.25C4.50331 5.35188 6.85188 3.00331 9.75 3H13.5V4.5H9.75C7.67996 4.50248 6.00248 6.17996 6 8.25V12.1275L7.9425 10.1925L9 11.25L5.25 15L1.5 11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RotateCounterclockwiseAlt.vue"]]);
